import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-join-org-success',
  templateUrl: './join-org-success.component.html',
  styleUrls: ['./join-org-success.component.scss'],
})
export class JoinOrgSuccessComponent implements OnInit {

  @Input() org: any;
  @Input() description : string;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    console.log(this.org);
  }

  dismiss(){
    this.modalController.dismiss();
  }

}
